import * as K from 'common/constants';
import { SortOrder } from 'common/graphqlTypes';

import { plugin } from 'plugins/deep-visibility';
import {
  DATA_SOURCE_CATEGORY_FIELD,
  DATA_SOURCE_NAME_FIELD,
  DATASOURCE,
  EVENT_DETAILS_FIELD,
  EVENT_SOURCE_FIELD,
  EVENT_TARGET_FIELD,
  EVENT_TIME_FIELD,
  EVENT_TYPE_FIELD,
  schemas,
} from 'schemas';
import { View, VIEW_NAME } from '../types';
import { DATA_SOURCE_CATEGORY_VALUE } from './constants';

// TODO: should come from Marketplace installed Apps API
const INSTALLED_DATA_SOURCES = [DATASOURCE.ATTIVO, DATASOURCE.OKTA, DATASOURCE.SENTINEL_ONE, DATASOURCE.VECTRA];

export const xdrView: View = {
  name: VIEW_NAME.XDR,
  label: 'XDR',
  order: 1,
  dataSources: INSTALLED_DATA_SOURCES,
  plugin: plugin.name,
  displaySettings: {
    columns: [
      EVENT_TIME_FIELD,
      DATA_SOURCE_NAME_FIELD,
      EVENT_TYPE_FIELD,
      EVENT_SOURCE_FIELD,
      EVENT_TARGET_FIELD,
      EVENT_DETAILS_FIELD,
    ],
    disableLiveTail: true,
    displayMode: K.DISPLAY_MODE.TABLE,
    fontFamily: K.FONT_FAMILY.REGULAR,
    searchAllTeamsByDefault: true,
    showChart: true,
    sortOrder: SortOrder.MOST_RECENT_AT_TOP,
  },
  filter: `${DATA_SOURCE_CATEGORY_FIELD} = '${DATA_SOURCE_CATEGORY_VALUE}'`,
  sources: {
    categoryField: DATA_SOURCE_CATEGORY_FIELD,
    categoryValue: DATA_SOURCE_CATEGORY_VALUE,
    sourceField: DATA_SOURCE_NAME_FIELD,
    sourceLabel: 'Vendor',
    sourceLabelPlural: 'Vendors',
    sourceValues: INSTALLED_DATA_SOURCES.map((source) => schemas[source].dataSourceId),
  },
  classNames: {
    tableField: 'DVTable__Cell',
    tableSeverityField: 'DVTable__SeverityField',
  },
};
